export enum FeatureFlags {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL'
}
